<header id="header" class="clearfix">
	<div class="central-wrapper clearfix">
		<ng-container *ngIf="dataHeader === undefined; else dashboard">
			<div class="logo_movil"><img src="assets/images/logo_pacific.svg" alt="Cooperativa Pacifico" /></div>
			<div class="timer_login">
				<!-- <img src="assets/images/cronometro.png" alt="cronometro" />Esta ventana se cerrará en
				<strong>45 segundos.</strong> -->
			</div>
		</ng-container>

		<ng-template #dashboard>
			<!-- <div class="timer_login">{{ 'Última Sesión: ' + dataHeader.lastSession }}</div> -->

			<div class="tipo_cambio">
				Tipo de Cambio (Soles X Dólares)
				<span
					>Compra: <strong>{{ dataHeader.buy }} </strong></span
				>
				<span
					>Venta: <strong>{{ dataHeader.sale }} </strong></span
				>
			</div>
		</ng-template>

		<div class="menu_right">
			<ul>
				<li>
					<a href="https://cp.com.pe/pacifico/in/general/personas/promociones-personas/" target="_blank">Promociones</a>
					<span>|</span>
				</li>
				<li><a (click)="onclick()" class="mostrar_legal">Legal</a> <span>|</span></li>
				<li><a href="https://cp.com.pe/pacifico/transparencia/" target="_blank">Transparencia</a> <span>|</span></li>
				<li><a href="https://cp.com.pe/pacifico/tarifario/" target="_blank">Tarifario</a> <span>|</span></li>
				<li><a href="https://cp.com.pe/pacifico/canales-de-contacto/" target="_blank">Contáctenos</a></li>
			</ul>
		</div>
	</div>
	<!-- Modal LEGAL-->
	<div class="modal_responsive" id="modalLegal" [hidden]="showLegal">
		<div class="filter_modal"></div>
		<div class="cont_modal">
			<div class="modal_legal">
				<span (click)="onclick()" class="modal-close"><img src="assets/images/icon_cerrar.png" alt="cerrar" /></span>
				<h3>Legal</h3>
				<p>
					Nuestros productos y servicios están sujetos a calificación, admisión y aprobación. Se aplican restricciones.
					Las tasas, comisiones, gastos y características de los productos y servicios se detallan en nuestra página web
					<a href="https://cp.com.pe/pacifico/" target="_blank"><strong>www.cp.com.pe</strong></a> y en la Plataforma de
					atención, a través del tarifario. Para acceder a los productos y servicios, usted debe ser socio de
					Cooperativa de Ahorro y Crédito Pacífico. Puede solicitar más información sobre los requisitos de afiliación a
					través del 719-2100 o nuestra página web. No captamos recursos del público, sólo operamos y captamos recursos
					de nuestros socios. Nos encontramos inscritos en el Registro Nacional de COOPAC, con el Registro
					N°001-2019-REG.COOPAC-SBS. Nos encontramos incorporados al Fondo de Seguro de Depósitos Cooperativo (FSDC);
					los depósitos de nuestros socios no se encuentran cubiertos por el FSDC, hasta dar cumplimiento a lo dispuesto
					por el artículo 5 de la Resolución SBS N° 5061-2018. Estamos regulados por la Superintendencia de Banca,
					Seguros y AFP (SBS) y supervisados por Superintendencia Adjunta de Cooperativas (SACOOP). Información
					difundida según lo indicado en la Vigésimo Cuarta Disposición Final y Complementaria de la Ley N° 26702,
					modificada por Ley N° 30822, la Resolución SBS N° 0480-2019, la Resolución SBS N° 3274-2017 y sus
					modificatorias, conforme a la normatividad vigente.
				</p>
				<div class="botones_modal">
					<a (click)="onclick()" class="button modal-close">Aceptar</a>
				</div>
			</div>
		</div>
	</div>
	<!-- Fin Modal LEGAL -->
</header>
